<template>
  <div>
    <br />
    <br />
    <div class="row align-items-end">
      <div class="col-xl-3 col-12">
        <label for="">Consignment <span class="text-danger">*</span></label>

        <vue-select :options="consignments" v-model="consignmentCost.consignment_reference" placeholder="Select an option"
          labelColumn="reference" valueColumn="reference" />

      </div>

      <div class="col-xl-2 col-12">
        <label for="">Total TTC </label>
        <input type="number" step="0.01" v-model="consignmentCost.totalPriceTTC" class="form-control" />
      </div>

      <div class="col-xl-2 col-12">
        <label for="">Total HT </label>
        <input type="number" step="0.01" v-model="consignmentCost.totalPriceHT" class="form-control" />
      </div>

      <div class="col-xl-2 col-12">
        <label for="">Total TVA </label>
        <input type="number" step="0.01" v-model="consignmentCost.totalPriceTVA" class="form-control" />
      </div>

      <div class="col-xl-2 col-12">
        <label for="">TVA % </label>
        <input type="number" step="0.01" v-model="consignmentCost.tva" class="form-control" />
      </div>

    </div>
    <br />
    <div class="row align-items-end">
      <div class="col-xl-3 col-12">
        <label for="">Méthode de paiement </label>
        <select v-model="consignmentCost.paymentMethod" class="form-control">
          <option value="">Sélectionner</option>
          <option value="cash">Espèces</option>
          <option value="cheque">Chèque</option>
          <option value="virement">Virement</option>
          <option value="transfer">Transfert</option>
        </select>
      </div>

      <div class="col-xl-3 col-12">
        <label for="">Date de paiement </label>
        <input type="date" v-model="consignmentCost.paymentDate" class="form-control" />
      </div>

      <div class="col-xl-3 col-12" v-if="consignmentCost.paymentMethod === 'cheque'">
        <label for="">Numéro de chèque </label>
        <input type="text" v-model="consignmentCost.cheque_number" class="form-control" />
      </div>

      <div class="col-xl-3 col-12" v-if="consignmentCost.paymentMethod === 'virement'">
        <label for="">Numéro de virement </label>
        <input type="text" v-model="consignmentCost.virement_number" class="form-control" />
      </div>

      <div class="col-xl-3 col-12" v-if="consignmentCost.paymentMethod === 'virement'">
        <label for="">Date de virement </label>
        <input type="date" v-model="consignmentCost.virementDate" class="form-control" />
      </div>

      <div class="col-xl-3 col-12" v-if="consignmentCost.paymentMethod === 'transfer'">
        <label for="">Numéro de transfert </label>
        <input type="text" v-model="consignmentCost.transfer_number" class="form-control" />
      </div>

      <div class="col-xl-3 col-12" v-if="consignmentCost.paymentMethod === 'transfer'">
        <label for="">Date de transfert </label>
        <input type="date" v-model="consignmentCost.transferDate" class="form-control" />
      </div>

      <div class="col-xl-12 col-12">
        <label for="">Remarque </label>
        <textarea v-model="consignmentCost.remark" class="form-control"></textarea>
      </div>

      <div class="col-xl-auto col">
        <label for=""></label>
        <button class="btn btn-success" @click="save(consignmentCost)">
          <i class="bi bi-plus-circle"></i> Enregistrer
        </button>
      </div>

      <div class="col-xl-auto col-auto">
        <button class="btn btn-secondary d-flex align-items-center" @click="refresh()">
          <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
          <span> Actualiser </span>
        </button>
      </div>
    </div>
    <br />

    <vue-data-table v-if="consignment.consignmentCosts" :headers="headers" :data="consignment.consignmentCosts" :items-per-page="10"
      :buttons="buttons" :summable-columns="summableColumns">

      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #cell-totalPriceHT="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.totalPriceHT > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceHT }}
        </span>
      </template>

      <template #cell-totalPriceTVA="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.totalPriceTVA > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTVA }}
        </span>
      </template>

    </vue-data-table>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12">

      </div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-success" @click="validated()">
          <i class="bi bi-arrow-right-circle"></i> Suivant
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      consignmentCost: {
        reference: "",
        consignment_reference: "",
        totalPriceTTC: "",
        totalPriceHT: "",
        totalPriceTVA: "",
        tva: "",
        paymentMethod: "",
        paymentDate: "",
        cheque_number: "",
        virement_number: "",
        virementDate: "",
        transfer_number: "",
        transferDate: "",
        remark: ""
      },
      accept: false,
      // Table headers configuration
      headers: [
        { field: 'cost_reference', label: 'Référence facture', class: '' },
        { field: 'totalPriceTTC', label: 'Total TTC', class: 'fw-bold', isAmount: true },
        { field: 'totalPriceHT', label: 'Total HT', class: 'fw-bold', isAmount: true },
        { field: 'totalPriceTVA', label: 'Total TVA', class: 'fw-bold', isAmount: true },
        { field: 'tva', label: 'TVA %', class: '' },
        { field: 'paymentMethod', label: 'Méthode de paiement', class: '' },
        { field: 'paymentDate', label: 'Date de paiement', class: '' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      // Button actions
      buttons: [
        {
          label: 'Modifier',
          icon: 'bi bi-pencil',
          class: 'btn btn-warning',
          action: (item) => {
            this.editCost(item);
          },
        },
        {
          label: 'Supprimer',
          icon: 'bi bi-trash',
          class: 'btn btn-danger',
          action: (item) => {
            this.deleteCost(item);
          },
        },
      ],
      // Columns to summarize
      summableColumns: [
        { field: 'totalPriceTTC', class: 'fw-bold' },
        { field: 'totalPriceHT', class: 'fw-bold' },
        { field: 'totalPriceTVA', class: 'fw-bold' },
      ],

    };
  },
  computed: {
    ...mapGetters("consignment", {
      consignments: "getAll",
      consignment: "getConsignment",
    }),
  },
  methods: {
    async save(data) {
      if (data.reference === "") {

        await (data.consignment_reference = this.consignment.reference);

        await this.$store.dispatch("consignment/storeCost", data);

        await (this.consignmentCost = {
          reference: "",
          consignment_reference: "",
          totalPriceTTC: "",
          totalPriceHT: "",
          totalPriceTVA: "",
          tva: "",
          paymentMethod: "",
          paymentDate: "",
          cheque_number: "",
          virement_number: "",
          virementDate: "",
          transfer_number: "",
          transferDate: "",
          remark: ""
        });

        await this.$store.dispatch("consignment/show", this.consignment.reference);

      }
      else {

        await (data.consignment_reference = this.consignment.reference);

        await this.$store.dispatch("consignment/updateCost", data);
        await (this.consignmentCost = {
          reference: "",
          consignment_reference: "",
          totalPriceTTC: "",
          totalPriceHT: "",
          totalPriceTVA: "",
          tva: "",
          paymentMethod: "",
          paymentDate: "",
          cheque_number: "",
          virement_number: "",
          virementDate: "",
          transfer_number: "",
          transferDate: "",
          remark: ""
        });
        // Navigate to details page after editing
        if (this.consignment && this.consignment.reference) {
          this.$router.push({
            name: "consignments-details",
            params: { reference: this.consignment.reference },
          });
        }
      }
    },

    async refresh() {
      await this.$store.dispatch("consignment/getAll");
      await this.$store.dispatch("consignment/show", this.consignment.reference);
    },
    async validated() {
      this.$router.push({
        name: "consignments-edit", params: {
          reference: this.consignment.reference
        }
      });
    },

    async editCost(item) {
      await (this.consignmentCost.reference = item.reference)
      await (this.consignmentCost.consignment_reference = item.consignment_reference)
      await (this.consignmentCost.totalPriceTTC = item.totalPriceTTC)
      await (this.consignmentCost.totalPriceHT = item.totalPriceHT)
      await (this.consignmentCost.totalPriceTVA = item.totalPriceTVA)
      await (this.consignmentCost.tva = item.tva)
      await (this.consignmentCost.paymentMethod = item.paymentMethod)
      await (this.consignmentCost.paymentDate = item.paymentDate)
      await (this.consignmentCost.cheque_number = item.cheque_number || "")
      await (this.consignmentCost.virement_number = item.virement_number || "")
      await (this.consignmentCost.virementDate = item.virementDate || "")
      await (this.consignmentCost.transfer_number = item.transfer_number || "")
      await (this.consignmentCost.transferDate = item.transferDate || "")
      await (this.consignmentCost.remark = item.remark || "")
    },
    async deleteCost(item) {
      await this.$store.dispatch("consignment/destroyCost", item.reference);
    },
  },
  async mounted() {
    await this.$store.dispatch("consignment/getAll");
    // Get consignment reference from route parameter
    const consignmentRef = this.$route.params.reference;
    if (consignmentRef) {
      await this.$store.dispatch("consignment/show", consignmentRef);
    }
  },
};
</script>
<style scoped></style>

